const UrlConstants = {
  base_url: "https://clearviz.co.in",
};

export default UrlConstants;
